import { render, staticRenderFns } from "./FormCheckBox.vue?vue&type=template&id=482c217c&scoped=true"
import script from "./FormCheckBox.vue?vue&type=script&lang=js"
export * from "./FormCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c217c",
  null
  
)

export default component.exports